import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { NavbarContainer,  UserInfo, ToggleButton } from "./Navbar.styles";
import styles from "./Navbar.module.css";

const Navbar = ({ username, userRole, onToggleSidebar, isSidebarOpen }) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("access_token");
        navigate("/");
    };

    return (
        <NavbarContainer>
            {/* Botão para abrir/fechar a Sidebar */}
            <ToggleButton onClick={onToggleSidebar}>
                {isSidebarOpen ? "☰ Fechar" : "☰ Abrir"}
            </ToggleButton>

            {/* Seção da direita: Informações do Usuário e Logout */}
            <div className={styles.rightSection}>
                <UserInfo>
                    <span className={styles.username}>{username}</span>
                    <span className={styles.userRole}>{userRole}</span>
                </UserInfo>

                {/* Botão de Logout */}
                <button className={styles.logoutButton} onClick={handleLogout}>
                    Sair
                </button>
            </div>
        </NavbarContainer>
    );
};


// PropTypes para melhor reusabilidade
Navbar.propTypes = {
    logo: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    userRole: PropTypes.string.isRequired,
    onToggleSidebar: PropTypes.func.isRequired,
    isSidebarOpen: PropTypes.bool.isRequired
};

export default Navbar;
